import React from 'react';
import { 
  Button, Grid2 as Grid, Typography, RadioGroup, Radio, FormControl,
  FormControlLabel, IconButton
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';

const FormForgotPass = ({ setPasos, setValue, value, navigate }) => {
  const recuperar = e => {
    e.preventDefault();
    setPasos(2);
  }

  return (
    <form noValidate onSubmit={recuperar}>
      <Grid container spacing={2} sx={{my: 3}}>
        <Grid size={12}>
          <Grid size={12}>
            <IconButton
              className="btn-icon"
              aria-label="back"
              onClick={() => navigate(-1)}
            >
              <ChevronLeftIcon />
            </IconButton>
          </Grid>
          <Grid className="step1-forgot" container direction="column">
            <Typography variant="h3" component="h3">¿Olvidaste tu contraseña?</Typography>
            <Typography component="p">No te preocupes. Ocurre. Elige cómo deseas autentificarte.</Typography>
          </Grid>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="celular"
              name="radio-buttons-group"
              value={value}
              onChange={(event) => setValue(event.target.value)}
            >
              <FormControlLabel 
                value="email"
                control={<Radio sx={{ color: "#D8DADC" }} />}
                label="Correo electrónico"
              />
              <FormControlLabel 
                value="celular"
                control={<Radio sx={{ color: "#D8DADC" }} />}
                label="Número celular"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Grid size={{ xs:8, lg:6 }}>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
        >
          Siguiente
        </Button>
      </Grid>
    </form>
  )
}

FormForgotPass.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  setPasos: PropTypes.func.isRequired
}

export default FormForgotPass;